interface AreaNaming {
  name?: string;
  areaNumber?: number | string;
  activityNumbers?: Record<string, number> | null;
}

interface ActivityNaming {
  id?: string;
  areaSingular?: string;
  areaPlural?: string;
}

export const getAreaSingular = (activity: ActivityNaming | undefined, legacySingular: string) =>
  activity?.areaSingular?.trim() || legacySingular;

export const getAreaPlural = (activity: ActivityNaming | undefined, legacyPlural: string) =>
  activity?.areaPlural?.trim() || legacyPlural;

export const getAreaNumber = (area: AreaNaming | undefined, activity?: ActivityNaming) => {
  const number = activity?.id ? area?.activityNumbers?.[activity.id] : undefined;
  return typeof number === "number" && Number.isInteger(number) && number > 0
    ? number
    : area?.areaNumber;
};

export const getAreaLabel = (
  area: AreaNaming | undefined,
  activity: ActivityNaming | undefined,
  legacySingular: string,
) => area?.name?.trim() || `${getAreaSingular(activity, legacySingular)} ${getAreaNumber(area, activity)}`;

export const getAreaOptionLabel = (
  area: AreaNaming | undefined,
  activity: ActivityNaming | undefined,
  legacySingular: string,
) => area?.name?.trim() || activity?.areaSingular?.trim()
  ? getAreaLabel(area, activity, legacySingular)
  : getAreaNumber(area, activity);